import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { WithTooltip } from '../../design-system'
import { TextInput } from '../../legacy-design-system/form-text'
import { CsHelpCircledIcon as HelpIcon } from '../../legacy-design-system/icons'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { SensitiveDataPolicy } from '.'
import { Row, Box } from '../../legacy-design-system/form'
import { MultiSelectCombobox } from '../../legacy-design-system/combobox'

interface Props {
  readonly policy: SensitiveDataPolicy
}

export function SensitiveDataTypeDefaults({ policy }: Props) {
  return (
    <Fragment>
      <Row>
        <Box basis={8}>
          <FormattedMessage id="title_sensitiveData_nameOfDataType">
            {(label) => (
              <TextInput label={label as any} value={policy.name} disabled />
            )}
          </FormattedMessage>
        </Box>
      </Row>
      <Row>
        <Box basis={8}>
          <div>
            <FormattedMessage
              id="title_sensitiveData_defaultKeywords"
              children={(msg) => (
                <span
                  className={css`
                    padding-top: 10px;
                    color: ${theme.color.neutral60};
                    font-weight: ${deprecatedTheme.fontWeights.primary.bold};
                  `}
                >
                  {msg}
                </span>
              )}
            />
            <div
              className={css`
                display: inline-block;
                vertical-align: text-top;
              `}
            >
              <WithTooltip
                renderTooltipContent={() => (
                  <div>
                    <FormattedMessage id="detail_sensitiveData_defaultKeywordsTooltip" />
                  </div>
                )}
                placement="right"
              >
                {({ onMouseEnter, onMouseLeave }) => (
                  <div
                    className={css`
                      margin-left: 5px;
                      margin-top: -3px;
                    `}
                  >
                    <HelpIcon
                      color={theme.color.neutral50}
                      height={16}
                      width={16}
                      onMouseEnter={onMouseEnter}
                      onMouseLeave={onMouseLeave}
                    />
                  </div>
                )}
              </WithTooltip>
            </div>
          </div>
          <div
            className={css`
              padding-top: 5px;
            `}
          >
            <MultiSelectCombobox<string>
              renderLabel={() => undefined}
              id="default-keywords-multi-select"
              values={policy.keywords}
              onChange={() => undefined}
              items={[]}
              disabled
            />
          </div>
        </Box>
      </Row>
    </Fragment>
  )
}
